import { create } from 'zustand';
import useTokenStore from './store';
import { getUnseenMatchCount } from '../utils/savedSearches';

// Unseen saved-search match count for the header badge. Not persisted — the
// count is cheap to refetch and stale-after-logout state must never leak
// between sessions. Fails closed to 0 (getUnseenMatchCount swallows errors).
interface SavedSearchStore {
  unseenCount: number;
  fetchUnseenCount: () => Promise<void>;
  clearUnseen: () => void;
}

export const useSavedSearchStore = create<SavedSearchStore>((set) => ({
  unseenCount: 0,
  fetchUnseenCount: async () => {
    const token = useTokenStore.getState().token;
    if (!token) {
      set({ unseenCount: 0 });
      return;
    }
    const count = await getUnseenMatchCount(token);
    // Drop the result if the session changed while the request was in
    // flight — buyer A's count must never surface after logout or an A → B
    // token swap.
    if (useTokenStore.getState().token !== token) return;
    set({ unseenCount: count });
  },
  clearUnseen: () => set({ unseenCount: 0 }),
}));
